import React from "react";
import './footer.css'
import {FaLinkedin, FaGithub} from "react-icons/fa"
import { profile } from "../../data/profile";

const Footer = () => {
    return(
        <footer>
            <div className="container footer__container">
                <p className="text-muted">© {new Date().getFullYear()} {profile.name}</p>
                <div className="footer__socials">
                    <a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin/></a>
                    <a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub"><FaGithub/></a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
